import React from "react"
import { Link } from 'react-router-dom';
import { SourcePropsWithMsgIds } from "../../props/sourceprops";
import SourceLink from "./SourceLink"



interface SourcesLinkProps {
    language: string;
    sources: SourcePropsWithMsgIds[];
}

const SourcesLink: React.FC<SourcesLinkProps> = ({ language, sources }) => {

    return (
        <React.Fragment>
            {sources.length > 0 &&
                <span style={{ display: 'block', paddingTop: '3px' }}>
                    {
                        sources.map((item, index) => {
                            return (
                                <span key={"source-link-" + item.source.name + "-" + index}>
                                    <SourceLink source={item.source} />
                                    {
                                        item.msgs.length > 0 &&
                                        <span style={{ display:'inline-block', paddingTop: '3px', maxWidth: 650 }}>
                                            &nbsp;{" ("}
                                            {
                                                item.msgs.map((idAndName, i) => (
                                                    <React.Fragment key={idAndName.id}>
                                                        <Link
                                                            to={`/${language}/${idAndName.id}`}
                                                        >
                                                            {idAndName.name}
                                                        </Link>
                                                        {i < item.msgs.length - 1 ? ', ' : ''}
                                                    </React.Fragment>
                                                ))
                                            }
                                            {")"}
                                        </span>
                                    }
                                </span>
                            )
                        })
                    }
                </span>
            }
        </React.Fragment>
    )
}


export default SourcesLink